import { extendObservable } from 'mobx';

import { initialState } from './constants';

class UserSegmentationStore {
  constructor() {
    extendObservable(this, initialState);
  }
}

export default new UserSegmentationStore();
